import { Component, Input, OnInit, input, output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { combineLatest } from 'rxjs';
import { Choice } from 'src/app/ballot/backend-types';
import { noSpecialCharsValidator } from '../write-in-choice/custom-validators'
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { writeInChoiceDescriptions } from 'src/app/ballot/ballot.component';

@Component({
    selector: 'app-write-in-choice',
    templateUrl: './write-in-choice.component.html',
    styleUrls: ['./write-in-choice.component.scss'],
    standalone: false
})
export class WriteInChoiceComponent implements OnInit {
  isChecked = false;
  choice = input.required<Choice>()
  descriptions  = input.required<writeInChoiceDescriptions[]>()
  selectedChoice = output<Choice>()
  @Input({ required: true }) ovalOnRight?: boolean;
  inputHasFocus: boolean = false;
  writeInForm: FormGroup;
  jsonDescription: string = '';
  maxLength: number = 80;

  constructor(private announcer: LiveAnnouncer) {
    this.writeInForm = new FormGroup({
      checkboxControl: new FormControl(false),
      writeInControl: new FormControl({ value: '', disabled: false }, [
        Validators.maxLength(this.maxLength),
        noSpecialCharsValidator()
      ])
    }); 
  }
  ngOnInit(): void {
    this.maxLength = +(this.choice().ballotMarkingMetadata?.writeInMaxLength ?? "80");
    this.jsonDescription = this.getChoiceDescriptionById()
    const checkboxControl = this.writeInForm.get('checkboxControl');
    const writeInControl = this.writeInForm.get('writeInControl');

    if (checkboxControl && writeInControl) {
      checkboxControl.valueChanges.subscribe(isChecked => {
        if (isChecked) {
          writeInControl.enable();
          writeInControl.addValidators(Validators.maxLength(this.maxLength));
          if(this.choice().description != this.jsonDescription){
            writeInControl.setValue(this.choice().description, { emitEvent: true });
          }          
        } else {
          writeInControl.disable();
          writeInControl.setValue('', { emitEvent: true });  
          writeInControl.markAsPristine();
          this.choice().description = this.jsonDescription
          writeInControl.markAsUntouched();
        }
      });
      
      checkboxControl.setValue(this.choice().selected, { emitEvent: true });

      combineLatest([
        this.writeInForm.valueChanges,
        this.writeInForm.statusChanges
      ]).subscribe(([formValue, status]) => {
        if (writeInControl.enabled) {
          if(writeInControl.valid){
            this.choice().description =  formValue.writeInControl
          }           
        }
      });
    }
}

 
handleContainerClick(event?: MouseEvent): void {
  if (event && event.target !== event.currentTarget) {
    return; 
  }

  const checkboxControl = this.writeInForm.get('checkboxControl');
  if (checkboxControl) {
    const updatedChoice = this.choice();
    updatedChoice.selected = !updatedChoice.selected;
    
    checkboxControl.setValue(updatedChoice.selected, { emitEvent: true });
    if (!updatedChoice.selected) {
      updatedChoice.description = this.jsonDescription;
    }
    this.selectedChoice.emit(updatedChoice);
  }
}


  handleFocus(): void {
    this.inputHasFocus = true;
  }

  handleBlur(): void {
    this.inputHasFocus = false;
  }

  handleKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Space' || event.code === 'Space') {
      this.handleContainerClick();
      event.preventDefault();
    }
  }

  get checkboxControl() {
    return this.writeInForm.get('checkboxControl');
  }
    
  clearState(): void {
    const checkboxControl = this.writeInForm.get('checkboxControl');
    if (checkboxControl) {
      this.choice().selected = false;
      this.choice().description = this.jsonDescription
      checkboxControl.setValue(this.choice().selected, { emitEvent: true });
    }
  }

  getChoiceDescriptionById(): string  {
    const choice = this.descriptions().find(c => c.id === this.choice().choiceId);
    return choice ? choice.description : '';
  }

}
